const token_testnet = {
	//dev-live
	address : "0x774678aB9EC5cdc0d01227f46d2bCaF851Eef88F",
	abi: [
	{
		"inputs": [
		{
			"internalType": "string",
			"name": "name",
			"type": "string"
		},
		{
			"internalType": "string",
			"name": "symbol",
			"type": "string"
		},
		{
			"internalType": "uint256",
			"name": "initialSupply",
			"type": "uint256"
		}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "spender",
			"type": "address"
		},
		{
			"indexed": false,
			"internalType": "uint256",
			"name": "value",
			"type": "uint256"
		}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"indexed": false,
			"internalType": "uint256",
			"name": "value",
			"type": "uint256"
		}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "spender",
			"type": "address"
		}
		],
		"name": "allowance",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "spender",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "amount",
			"type": "uint256"
		}
		],
		"name": "approve",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "balanceOf",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "decimals",
		"outputs": [
		{
			"internalType": "uint8",
			"name": "",
			"type": "uint8"
		}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "spender",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "subtractedValue",
			"type": "uint256"
		}
		],
		"name": "decreaseAllowance",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "spender",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "addedValue",
			"type": "uint256"
		}
		],
		"name": "increaseAllowance",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "amount",
			"type": "uint256"
		}
		],
		"name": "transfer",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "amount",
			"type": "uint256"
		}
		],
		"name": "transferFrom",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	}
	]
}

const token_live = {
	// live-live
	address : "0x4c601dc69affb0d4fc8de1ac303705e432a4a27e",
	abi: [
		{
		"inputs": [
		{
		"internalType": "string",
		"name": "name",
		"type": "string"
		},
		{
		"internalType": "string",
		"name": "symbol",
		"type": "string"
		},
		{
		"internalType": "uint256",
		"name": "initialSupply",
		"type": "uint256"
		}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
		},
		{
		"anonymous": false,
		"inputs": [
		{
		"indexed": true,
		"internalType": "address",
		"name": "owner",
		"type": "address"
		},
		{
		"indexed": true,
		"internalType": "address",
		"name": "spender",
		"type": "address"
		},
		{
		"indexed": false,
		"internalType": "uint256",
		"name": "value",
		"type": "uint256"
		}
		],
		"name": "Approval",
		"type": "event"
		},
		{
		"anonymous": false,
		"inputs": [
		{
		"indexed": true,
		"internalType": "address",
		"name": "from",
		"type": "address"
		},
		{
		"indexed": true,
		"internalType": "address",
		"name": "to",
		"type": "address"
		},
		{
		"indexed": false,
		"internalType": "uint256",
		"name": "value",
		"type": "uint256"
		}
		],
		"name": "Transfer",
		"type": "event"
		},
		{
		"inputs": [
		{
		"internalType": "address",
		"name": "owner",
		"type": "address"
		},
		{
		"internalType": "address",
		"name": "spender",
		"type": "address"
		}
		],
		"name": "allowance",
		"outputs": [
		{
		"internalType": "uint256",
		"name": "",
		"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function"
		},
		{
		"inputs": [
		{
		"internalType": "address",
		"name": "spender",
		"type": "address"
		},
		{
		"internalType": "uint256",
		"name": "amount",
		"type": "uint256"
		}
		],
		"name": "approve",
		"outputs": [
		{
		"internalType": "bool",
		"name": "",
		"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
		},
		{
		"inputs": [
		{
		"internalType": "address",
		"name": "account",
		"type": "address"
		}
		],
		"name": "balanceOf",
		"outputs": [
		{
		"internalType": "uint256",
		"name": "",
		"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function"
		},
		{
		"inputs": [],
		"name": "decimals",
		"outputs": [
		{
		"internalType": "uint8",
		"name": "",
		"type": "uint8"
		}
		],
		"stateMutability": "view",
		"type": "function"
		},
		{
		"inputs": [
		{
		"internalType": "address",
		"name": "spender",
		"type": "address"
		},
		{
		"internalType": "uint256",
		"name": "subtractedValue",
		"type": "uint256"
		}
		],
		"name": "decreaseAllowance",
		"outputs": [
		{
		"internalType": "bool",
		"name": "",
		"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
		},
		{
		"inputs": [
		{
		"internalType": "address",
		"name": "spender",
		"type": "address"
		},
		{
		"internalType": "uint256",
		"name": "addedValue",
		"type": "uint256"
		}
		],
		"name": "increaseAllowance",
		"outputs": [
		{
		"internalType": "bool",
		"name": "",
		"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
		},
		{
		"inputs": [],
		"name": "name",
		"outputs": [
		{
		"internalType": "string",
		"name": "",
		"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function"
		},
		{
		"inputs": [],
		"name": "symbol",
		"outputs": [
		{
		"internalType": "string",
		"name": "",
		"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function"
		},
		{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
		{
		"internalType": "uint256",
		"name": "",
		"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function"
		},
		{
		"inputs": [
		{
		"internalType": "address",
		"name": "to",
		"type": "address"
		},
		{
		"internalType": "uint256",
		"name": "amount",
		"type": "uint256"
		}
		],
		"name": "transfer",
		"outputs": [
		{
		"internalType": "bool",
		"name": "",
		"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
		},
		{
		"inputs": [
		{
		"internalType": "address",
		"name": "from",
		"type": "address"
		},
		{
		"internalType": "address",
		"name": "to",
		"type": "address"
		},
		{
		"internalType": "uint256",
		"name": "amount",
		"type": "uint256"
		}
		],
		"name": "transferFrom",
		"outputs": [
		{
		"internalType": "bool",
		"name": "",
		"type": "bool"
		}
		],
		"stateMutability": "nonpayable",
		"type": "function"
		}
		]
}

const staking_testnet = {
	//dev-live
	address: "0xc91902C700bF7761626449D989e9733e284d3eeB",
	abi:[
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "previousAdmin",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "newAdmin",
				"type": "address"
			}
			],
			"name": "AdminChanged",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "beacon",
				"type": "address"
			}
			],
			"name": "BeaconUpgraded",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": false,
				"internalType": "uint8",
				"name": "version",
				"type": "uint8"
			}
			],
			"name": "Initialized",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "previousAdminRole",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "newAdminRole",
				"type": "bytes32"
			}
			],
			"name": "RoleAdminChanged",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "sender",
				"type": "address"
			}
			],
			"name": "RoleGranted",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "sender",
				"type": "address"
			}
			],
			"name": "RoleRevoked",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "timestamp",
				"type": "uint256"
			}
			],
			"name": "Staked",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "timestamp",
				"type": "uint256"
			}
			],
			"name": "Unstaked",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "implementation",
				"type": "address"
			}
			],
			"name": "Upgraded",
			"type": "event"
		},
		{
			"stateMutability": "payable",
			"type": "fallback"
		},
		{
			"inputs": [],
			"name": "CONTRACT_RENOUNCED",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "addr",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "expireTime",
				"type": "uint256"
			}
			],
			"name": "ChangeDueDate",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "a",
				"type": "uint256"
			}
			],
			"name": "ChangeMinimumStakingAmount",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "a",
				"type": "uint256"
			}
			],
			"name": "ChangeMinimumStakingUsd",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "a",
				"type": "uint256"
			}
			],
			"name": "ChangeUnstakeableFee",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "CheckContractRenounced",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "DEFAULT_ADMIN_ROLE",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_yield",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "expireTime",
				"type": "uint256"
			}
			],
			"name": "FixedTokenStake",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
			],
			"name": "ForcedWithdrawStake",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStakeJoinDate",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStaker",
			"outputs": [
			{
				"components": [
				{
					"internalType": "address",
					"name": "addr",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "total_stake",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "contribution",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "yield",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "earned_yield",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "last_yield_time",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "unstakeable",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "joined",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "joinedUsdPrice",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "dueDate",
					"type": "uint256"
				},
				{
					"internalType": "bool",
					"name": "exists",
					"type": "bool"
				}
				],
				"internalType": "struct KCTStake_Storage_V1.Staker",
				"name": "",
				"type": "tuple"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStakerPercentageByAddress",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "addr",
				"type": "address"
			}
			],
			"name": "GetStakerUnstakeableAmount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStakerYield",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStakingAmount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetTotalStakeAmount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "MINIMUM_STAKE_AMOUNT",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "MINIMUM_STAKE_USD",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "MINIMUM_TOKEN_STAKE_ERROR",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "MINIMUM_USD_STAKE_ERROR",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "NEVER_STAKED_ERROR",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "NO_ETH_STAKED_ERROR",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "RenounceContract",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "STAKING_MANAGER_ROLE",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "StakerCount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "StakerExists",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "SweepETH",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "SweepToken",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "TOKEN",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "UNSTAKEABLE_FEE",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "UnstakeAll",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "_token",
				"type": "address"
			}
			],
			"name": "UpdateToken",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "usdPrice",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_yield",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "expireTime",
				"type": "uint256"
			}
			],
			"name": "UsdPriceStake",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "WithdrawStake",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
			],
			"name": "calculateYield",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "claimYield",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			}
			],
			"name": "getRoleAdmin",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
			],
			"name": "getRoleMember",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			}
			],
			"name": "getRoleMemberCount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "grantRole",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "hasRole",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "_tokenAddr",
				"type": "address"
			}
			],
			"name": "initialize",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "owner",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "proxiableUUID",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "renounceRole",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "revokeRole",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"name": "stakerList",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"name": "stakers",
			"outputs": [
			{
				"internalType": "address",
				"name": "addr",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "total_stake",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "contribution",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "yield",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "earned_yield",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "last_yield_time",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "unstakeable",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "joined",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "joinedUsdPrice",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "dueDate",
				"type": "uint256"
			},
			{
				"internalType": "bool",
				"name": "exists",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes4",
				"name": "interfaceId",
				"type": "bytes4"
			}
			],
			"name": "supportsInterface",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "newImplementation",
				"type": "address"
			}
			],
			"name": "upgradeTo",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "newImplementation",
				"type": "address"
			},
			{
				"internalType": "bytes",
				"name": "data",
				"type": "bytes"
			}
			],
			"name": "upgradeToAndCall",
			"outputs": [],
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"stateMutability": "payable",
			"type": "receive"
		}
	]
}

const staking_live = {
	//live-live
	address: "0x2F290CaC39053Ca4a67a4bB91f9DebA8Cca1008a",
	abi:[
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "previousAdmin",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "newAdmin",
				"type": "address"
			}
			],
			"name": "AdminChanged",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "beacon",
				"type": "address"
			}
			],
			"name": "BeaconUpgraded",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": false,
				"internalType": "uint8",
				"name": "version",
				"type": "uint8"
			}
			],
			"name": "Initialized",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "previousAdminRole",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "newAdminRole",
				"type": "bytes32"
			}
			],
			"name": "RoleAdminChanged",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "sender",
				"type": "address"
			}
			],
			"name": "RoleGranted",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "sender",
				"type": "address"
			}
			],
			"name": "RoleRevoked",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "timestamp",
				"type": "uint256"
			}
			],
			"name": "Staked",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "timestamp",
				"type": "uint256"
			}
			],
			"name": "Unstaked",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "implementation",
				"type": "address"
			}
			],
			"name": "Upgraded",
			"type": "event"
		},
		{
			"stateMutability": "payable",
			"type": "fallback"
		},
		{
			"inputs": [],
			"name": "CONTRACT_RENOUNCED",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "addr",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "expireTime",
				"type": "uint256"
			}
			],
			"name": "ChangeDueDate",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "a",
				"type": "uint256"
			}
			],
			"name": "ChangeMinimumStakingAmount",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "a",
				"type": "uint256"
			}
			],
			"name": "ChangeMinimumStakingUsd",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "a",
				"type": "uint256"
			}
			],
			"name": "ChangeUnstakeableFee",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "CheckContractRenounced",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "DEFAULT_ADMIN_ROLE",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_yield",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "expireTime",
				"type": "uint256"
			}
			],
			"name": "FixedTokenStake",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
			],
			"name": "ForcedWithdrawStake",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStakeJoinDate",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStaker",
			"outputs": [
			{
				"components": [
				{
					"internalType": "address",
					"name": "addr",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "total_stake",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "contribution",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "yield",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "earned_yield",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "last_yield_time",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "unstakeable",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "joined",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "joinedUsdPrice",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "dueDate",
					"type": "uint256"
				},
				{
					"internalType": "bool",
					"name": "exists",
					"type": "bool"
				}
				],
				"internalType": "struct KCTStake_Storage_V1.Staker",
				"name": "",
				"type": "tuple"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStakerPercentageByAddress",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "addr",
				"type": "address"
			}
			],
			"name": "GetStakerUnstakeableAmount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStakerYield",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetStakingAmount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "GetTotalStakeAmount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "MINIMUM_STAKE_AMOUNT",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "MINIMUM_STAKE_USD",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "MINIMUM_TOKEN_STAKE_ERROR",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "MINIMUM_USD_STAKE_ERROR",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "NEVER_STAKED_ERROR",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "NO_ETH_STAKED_ERROR",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "RenounceContract",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "STAKING_MANAGER_ROLE",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "StakerCount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "a",
				"type": "address"
			}
			],
			"name": "StakerExists",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "SweepETH",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "SweepToken",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "TOKEN",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "UNSTAKEABLE_FEE",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "UnstakeAll",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "_token",
				"type": "address"
			}
			],
			"name": "UpdateToken",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "usdPrice",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_yield",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "expireTime",
				"type": "uint256"
			}
			],
			"name": "UsdPriceStake",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "WithdrawStake",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
			],
			"name": "calculateYield",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "claimYield",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			}
			],
			"name": "getRoleAdmin",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
			],
			"name": "getRoleMember",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			}
			],
			"name": "getRoleMemberCount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "grantRole",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "hasRole",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "_tokenAddr",
				"type": "address"
			}
			],
			"name": "initialize",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "owner",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "proxiableUUID",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "renounceRole",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "revokeRole",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"name": "stakerList",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"name": "stakers",
			"outputs": [
			{
				"internalType": "address",
				"name": "addr",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "total_stake",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "contribution",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "yield",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "earned_yield",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "last_yield_time",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "unstakeable",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "joined",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "joinedUsdPrice",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "dueDate",
				"type": "uint256"
			},
			{
				"internalType": "bool",
				"name": "exists",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes4",
				"name": "interfaceId",
				"type": "bytes4"
			}
			],
			"name": "supportsInterface",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "newImplementation",
				"type": "address"
			}
			],
			"name": "upgradeTo",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "newImplementation",
				"type": "address"
			},
			{
				"internalType": "bytes",
				"name": "data",
				"type": "bytes"
			}
			],
			"name": "upgradeToAndCall",
			"outputs": [],
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"stateMutability": "payable",
			"type": "receive"
		}
	]
}

export const shillaContract_testnet = {
	// ERC-721 신라 컨트랙
	//dev-live
	address: '0xf5fD917388936553912508C820330695239014dC',
	abi: [
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": false,
			"internalType": "address",
			"name": "previousAdmin",
			"type": "address"
		},
		{
			"indexed": false,
			"internalType": "address",
			"name": "newAdmin",
			"type": "address"
		}
		],
		"name": "AdminChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "approved",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "operator",
			"type": "address"
		},
		{
			"indexed": false,
			"internalType": "bool",
			"name": "approved",
			"type": "bool"
		}
		],
		"name": "ApprovalForAll",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "beacon",
			"type": "address"
		}
		],
		"name": "BeaconUpgraded",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "previousOwner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "newOwner",
			"type": "address"
		}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "previousAdminRole",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "newAdminRole",
			"type": "bytes32"
		}
		],
		"name": "RoleAdminChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "account",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "sender",
			"type": "address"
		}
		],
		"name": "RoleGranted",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "account",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "sender",
			"type": "address"
		}
		],
		"name": "RoleRevoked",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "implementation",
			"type": "address"
		}
		],
		"name": "Upgraded",
		"type": "event"
	},
	{
		"inputs": [],
		"name": "DEFAULT_ADMIN_ROLE",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "MINTER_ROLE",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "approve",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		}
		],
		"name": "balanceOf",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "getApproved",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		}
		],
		"name": "getRoleAdmin",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "uint256",
			"name": "index",
			"type": "uint256"
		}
		],
		"name": "getRoleMember",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		}
		],
		"name": "getRoleMemberCount",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "grantRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "hasRole",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "operator",
			"type": "address"
		}
		],
		"name": "isApprovedForAll",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "ownerOf",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "proxiableUUID",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "renounceRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "revokeRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "safeTransferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		},
		{
			"internalType": "bytes",
			"name": "_data",
			"type": "bytes"
		}
		],
		"name": "safeTransferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "operator",
			"type": "address"
		},
		{
			"internalType": "bool",
			"name": "approved",
			"type": "bool"
		}
		],
		"name": "setApprovalForAll",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "index",
			"type": "uint256"
		}
		],
		"name": "tokenByIndex",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "index",
			"type": "uint256"
		}
		],
		"name": "tokenOfOwnerByIndex",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "transferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "newOwner",
			"type": "address"
		}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "newImplementation",
			"type": "address"
		}
		],
		"name": "upgradeTo",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "newImplementation",
			"type": "address"
		},
		{
			"internalType": "bytes",
			"name": "data",
			"type": "bytes"
		}
		],
		"name": "upgradeToAndCall",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function",
		"payable": true
	},
	{
		"inputs": [
		{
			"internalType": "string",
			"name": "name",
			"type": "string"
		},
		{
			"internalType": "string",
			"name": "symbol",
			"type": "string"
		}
		],
		"name": "initialize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "redeemer",
			"type": "address"
		},
		{
			"components": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minPrice",
				"type": "uint256"
			},
			{
				"internalType": "string",
				"name": "uri",
				"type": "string"
			},
			{
				"internalType": "bytes",
				"name": "signature",
				"type": "bytes"
			}
			],
			"internalType": "struct LazyNFT_V1.NFTVoucher",
			"name": "voucher",
			"type": "tuple"
		}
		],
		"name": "redeem",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "payable",
		"type": "function",
		"payable": true
	},
	{
		"inputs": [],
		"name": "withdraw",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "availableToWithdraw",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "getChainID",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes4",
			"name": "interfaceId",
			"type": "bytes4"
		}
		],
		"name": "supportsInterface",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "tokenURI",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		},
		{
			"internalType": "string",
			"name": "tokenURI_",
			"type": "string"
		}
		],
		"name": "mintNFT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "_owner",
			"type": "address"
		}
		],
		"name": "getTokenIds",
		"outputs": [
		{
			"internalType": "uint256[]",
			"name": "",
			"type": "uint256[]"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "lockNFT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "unlockNFT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "burn",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		},
		{
			"internalType": "string",
			"name": "tokenURI_",
			"type": "string"
		}
		],
		"name": "resetURI",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
	]
};
export const LockupShillaContract_testnet = {
	// 22-09-22 lockup version
	address: '0xD00f34FF2C3F68a97e35D510831Cc3f0389A864A',
	abi:[
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "previousAdmin",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "newAdmin",
				"type": "address"
			}
			],
			"name": "AdminChanged",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "approved",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "Approval",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "operator",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "bool",
				"name": "approved",
				"type": "bool"
			}
			],
			"name": "ApprovalForAll",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "beacon",
				"type": "address"
			}
			],
			"name": "BeaconUpgraded",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "previousAdminRole",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "newAdminRole",
				"type": "bytes32"
			}
			],
			"name": "RoleAdminChanged",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "sender",
				"type": "address"
			}
			],
			"name": "RoleGranted",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "sender",
				"type": "address"
			}
			],
			"name": "RoleRevoked",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "Transfer",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "implementation",
				"type": "address"
			}
			],
			"name": "Upgraded",
			"type": "event"
		},
		{
			"inputs": [],
			"name": "DEFAULT_ADMIN_ROLE",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [],
			"name": "MINTER_ROLE",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "approve",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
			],
			"name": "balanceOf",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "getApproved",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			}
			],
			"name": "getRoleAdmin",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
			],
			"name": "getRoleMember",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			}
			],
			"name": "getRoleMemberCount",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "grantRole",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "hasRole",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "operator",
				"type": "address"
			}
			],
			"name": "isApprovedForAll",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [],
			"name": "name",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [],
			"name": "owner",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "ownerOf",
			"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [],
			"name": "proxiableUUID",
			"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "renounceRole",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
			],
			"name": "revokeRole",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "safeTransferFrom",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "bytes",
				"name": "_data",
				"type": "bytes"
			}
			],
			"name": "safeTransferFrom",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "operator",
				"type": "address"
			},
			{
				"internalType": "bool",
				"name": "approved",
				"type": "bool"
			}
			],
			"name": "setApprovalForAll",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "symbol",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
			],
			"name": "tokenByIndex",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
			],
			"name": "tokenOfOwnerByIndex",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [],
			"name": "totalSupply",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "transferFrom",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "newImplementation",
				"type": "address"
			}
			],
			"name": "upgradeTo",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "newImplementation",
				"type": "address"
			},
			{
				"internalType": "bytes",
				"name": "data",
				"type": "bytes"
			}
			],
			"name": "upgradeToAndCall",
			"outputs": [],
			"stateMutability": "payable",
			"type": "function",
			"payable": true
		},
		{
			"inputs": [
			{
				"internalType": "string",
				"name": "name",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "symbol",
				"type": "string"
			}
			],
			"name": "initialize",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "redeemer",
				"type": "address"
			},
			{
				"components": [
				{
					"internalType": "uint256",
					"name": "tokenId",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "minPrice",
					"type": "uint256"
				},
				{
					"internalType": "string",
					"name": "uri",
					"type": "string"
				},
				{
					"internalType": "bytes",
					"name": "signature",
					"type": "bytes"
				}
				],
				"internalType": "struct LazyNFT_V1.NFTVoucher",
				"name": "voucher",
				"type": "tuple"
			}
			],
			"name": "redeem",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "payable",
			"type": "function",
			"payable": true
		},
		{
			"inputs": [],
			"name": "withdraw",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "availableToWithdraw",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [],
			"name": "getChainID",
			"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "bytes4",
				"name": "interfaceId",
				"type": "bytes4"
			}
			],
			"name": "supportsInterface",
			"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "tokenURI",
			"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "string",
				"name": "tokenURI_",
				"type": "string"
			}
			],
			"name": "mintNFT",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "address",
				"name": "_owner",
				"type": "address"
			}
			],
			"name": "getTokenIds",
			"outputs": [
			{
				"internalType": "uint256[]",
				"name": "",
				"type": "uint256[]"
			}
			],
			"stateMutability": "view",
			"type": "function",
			"constant": true
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "lockNFT",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "unlockNFT",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			}
			],
			"name": "burn",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "string",
				"name": "tokenURI_",
				"type": "string"
			}
			],
			"name": "resetURI",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		}
		]
}

export const shillaContract_live = {
	// ERC-721 신라 컨트랙
	//live-live
	address: "0x9ffF9D0322DDd7BfDbbc772e0be544194d8aBCe0",
	abi: [
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": false,
			"internalType": "address",
			"name": "previousAdmin",
			"type": "address"
		},
		{
			"indexed": false,
			"internalType": "address",
			"name": "newAdmin",
			"type": "address"
		}
		],
		"name": "AdminChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "approved",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "operator",
			"type": "address"
		},
		{
			"indexed": false,
			"internalType": "bool",
			"name": "approved",
			"type": "bool"
		}
		],
		"name": "ApprovalForAll",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "beacon",
			"type": "address"
		}
		],
		"name": "BeaconUpgraded",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "previousOwner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "newOwner",
			"type": "address"
		}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "previousAdminRole",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "newAdminRole",
			"type": "bytes32"
		}
		],
		"name": "RoleAdminChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "account",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "sender",
			"type": "address"
		}
		],
		"name": "RoleGranted",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "account",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "sender",
			"type": "address"
		}
		],
		"name": "RoleRevoked",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "implementation",
			"type": "address"
		}
		],
		"name": "Upgraded",
		"type": "event"
	},
	{
		"inputs": [],
		"name": "DEFAULT_ADMIN_ROLE",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "MINTER_ROLE",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "approve",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		}
		],
		"name": "balanceOf",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "getApproved",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		}
		],
		"name": "getRoleAdmin",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "uint256",
			"name": "index",
			"type": "uint256"
		}
		],
		"name": "getRoleMember",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		}
		],
		"name": "getRoleMemberCount",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "grantRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "hasRole",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "operator",
			"type": "address"
		}
		],
		"name": "isApprovedForAll",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "ownerOf",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "proxiableUUID",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "renounceRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "revokeRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "safeTransferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		},
		{
			"internalType": "bytes",
			"name": "_data",
			"type": "bytes"
		}
		],
		"name": "safeTransferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "operator",
			"type": "address"
		},
		{
			"internalType": "bool",
			"name": "approved",
			"type": "bool"
		}
		],
		"name": "setApprovalForAll",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "index",
			"type": "uint256"
		}
		],
		"name": "tokenByIndex",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "index",
			"type": "uint256"
		}
		],
		"name": "tokenOfOwnerByIndex",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "transferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "newOwner",
			"type": "address"
		}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "newImplementation",
			"type": "address"
		}
		],
		"name": "upgradeTo",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "newImplementation",
			"type": "address"
		},
		{
			"internalType": "bytes",
			"name": "data",
			"type": "bytes"
		}
		],
		"name": "upgradeToAndCall",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function",
		"payable": true
	},
	{
		"inputs": [
		{
			"internalType": "string",
			"name": "name",
			"type": "string"
		},
		{
			"internalType": "string",
			"name": "symbol",
			"type": "string"
		}
		],
		"name": "initialize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "redeemer",
			"type": "address"
		},
		{
			"components": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minPrice",
				"type": "uint256"
			},
			{
				"internalType": "string",
				"name": "uri",
				"type": "string"
			},
			{
				"internalType": "bytes",
				"name": "signature",
				"type": "bytes"
			}
			],
			"internalType": "struct LazyNFT_V1.NFTVoucher",
			"name": "voucher",
			"type": "tuple"
		}
		],
		"name": "redeem",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "payable",
		"type": "function",
		"payable": true
	},
	{
		"inputs": [],
		"name": "withdraw",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "availableToWithdraw",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "getChainID",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes4",
			"name": "interfaceId",
			"type": "bytes4"
		}
		],
		"name": "supportsInterface",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "tokenURI",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		},
		{
			"internalType": "string",
			"name": "tokenURI_",
			"type": "string"
		}
		],
		"name": "mintNFT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "_owner",
			"type": "address"
		}
		],
		"name": "getTokenIds",
		"outputs": [
		{
			"internalType": "uint256[]",
			"name": "",
			"type": "uint256[]"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "lockNFT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "unlockNFT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "burn",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		},
		{
			"internalType": "string",
			"name": "tokenURI_",
			"type": "string"
		}
		],
		"name": "resetURI",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
	]
};

export const LockupShillaContract_live = {
	// 22-09-28 lockup version
	//live-live
	address: "0x4CeA250DB89fD76D62646E1Aa2349b1Fd6645516",
	abi: [
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": false,
			"internalType": "address",
			"name": "previousAdmin",
			"type": "address"
		},
		{
			"indexed": false,
			"internalType": "address",
			"name": "newAdmin",
			"type": "address"
		}
		],
		"name": "AdminChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "approved",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "operator",
			"type": "address"
		},
		{
			"indexed": false,
			"internalType": "bool",
			"name": "approved",
			"type": "bool"
		}
		],
		"name": "ApprovalForAll",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "beacon",
			"type": "address"
		}
		],
		"name": "BeaconUpgraded",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "previousOwner",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "newOwner",
			"type": "address"
		}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "previousAdminRole",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "newAdminRole",
			"type": "bytes32"
		}
		],
		"name": "RoleAdminChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "account",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "sender",
			"type": "address"
		}
		],
		"name": "RoleGranted",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "account",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "sender",
			"type": "address"
		}
		],
		"name": "RoleRevoked",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"indexed": true,
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
		{
			"indexed": true,
			"internalType": "address",
			"name": "implementation",
			"type": "address"
		}
		],
		"name": "Upgraded",
		"type": "event"
	},
	{
		"inputs": [],
		"name": "DEFAULT_ADMIN_ROLE",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "MINTER_ROLE",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "approve",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		}
		],
		"name": "balanceOf",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "getApproved",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		}
		],
		"name": "getRoleAdmin",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "uint256",
			"name": "index",
			"type": "uint256"
		}
		],
		"name": "getRoleMember",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		}
		],
		"name": "getRoleMemberCount",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "grantRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "hasRole",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "operator",
			"type": "address"
		}
		],
		"name": "isApprovedForAll",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "ownerOf",
		"outputs": [
		{
			"internalType": "address",
			"name": "",
			"type": "address"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "proxiableUUID",
		"outputs": [
		{
			"internalType": "bytes32",
			"name": "",
			"type": "bytes32"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "renounceRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "bytes32",
			"name": "role",
			"type": "bytes32"
		},
		{
			"internalType": "address",
			"name": "account",
			"type": "address"
		}
		],
		"name": "revokeRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "safeTransferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		},
		{
			"internalType": "bytes",
			"name": "_data",
			"type": "bytes"
		}
		],
		"name": "safeTransferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "operator",
			"type": "address"
		},
		{
			"internalType": "bool",
			"name": "approved",
			"type": "bool"
		}
		],
		"name": "setApprovalForAll",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "index",
			"type": "uint256"
		}
		],
		"name": "tokenByIndex",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "owner",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "index",
			"type": "uint256"
		}
		],
		"name": "tokenOfOwnerByIndex",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "from",
			"type": "address"
		},
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "transferFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "newOwner",
			"type": "address"
		}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "newImplementation",
			"type": "address"
		}
		],
		"name": "upgradeTo",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "newImplementation",
			"type": "address"
		},
		{
			"internalType": "bytes",
			"name": "data",
			"type": "bytes"
		}
		],
		"name": "upgradeToAndCall",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function",
		"payable": true
	},
	{
		"inputs": [
		{
			"internalType": "string",
			"name": "name",
			"type": "string"
		},
		{
			"internalType": "string",
			"name": "symbol",
			"type": "string"
		}
		],
		"name": "initialize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "redeemer",
			"type": "address"
		},
		{
			"components": [
			{
				"internalType": "uint256",
				"name": "tokenId",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minPrice",
				"type": "uint256"
			},
			{
				"internalType": "string",
				"name": "uri",
				"type": "string"
			},
			{
				"internalType": "bytes",
				"name": "signature",
				"type": "bytes"
			}
			],
			"internalType": "struct LazyNFT_V1.NFTVoucher",
			"name": "voucher",
			"type": "tuple"
		}
		],
		"name": "redeem",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "payable",
		"type": "function",
		"payable": true
	},
	{
		"inputs": [],
		"name": "withdraw",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "availableToWithdraw",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [],
		"name": "getChainID",
		"outputs": [
		{
			"internalType": "uint256",
			"name": "",
			"type": "uint256"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "bytes4",
			"name": "interfaceId",
			"type": "bytes4"
		}
		],
		"name": "supportsInterface",
		"outputs": [
		{
			"internalType": "bool",
			"name": "",
			"type": "bool"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "tokenURI",
		"outputs": [
		{
			"internalType": "string",
			"name": "",
			"type": "string"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "to",
			"type": "address"
		},
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		},
		{
			"internalType": "string",
			"name": "tokenURI_",
			"type": "string"
		}
		],
		"name": "mintNFT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "address",
			"name": "_owner",
			"type": "address"
		}
		],
		"name": "getTokenIds",
		"outputs": [
		{
			"internalType": "uint256[]",
			"name": "",
			"type": "uint256[]"
		}
		],
		"stateMutability": "view",
		"type": "function",
		"constant": true
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "lockNFT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "unlockNFT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		}
		],
		"name": "burn",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
		{
			"internalType": "uint256",
			"name": "tokenId",
			"type": "uint256"
		},
		{
			"internalType": "string",
			"name": "tokenURI_",
			"type": "string"
		}
		],
		"name": "resetURI",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
	]
};

export const pfpContract_testnet = {
	address: "0xD938E2a0Dd52d816293a9b9546975812BD1c4da3",
	abi: [
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": false,
			  "internalType": "address",
			  "name": "previousAdmin",
			  "type": "address"
			},
			{
			  "indexed": false,
			  "internalType": "address",
			  "name": "newAdmin",
			  "type": "address"
			}
		  ],
		  "name": "AdminChanged",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "approved",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "Approval",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "operator",
			  "type": "address"
			},
			{
			  "indexed": false,
			  "internalType": "bool",
			  "name": "approved",
			  "type": "bool"
			}
		  ],
		  "name": "ApprovalForAll",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "beacon",
			  "type": "address"
			}
		  ],
		  "name": "BeaconUpgraded",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "previousOwner",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "newOwner",
			  "type": "address"
			}
		  ],
		  "name": "OwnershipTransferred",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "previousAdminRole",
			  "type": "bytes32"
			},
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "newAdminRole",
			  "type": "bytes32"
			}
		  ],
		  "name": "RoleAdminChanged",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "sender",
			  "type": "address"
			}
		  ],
		  "name": "RoleGranted",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "sender",
			  "type": "address"
			}
		  ],
		  "name": "RoleRevoked",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "from",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "Transfer",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "implementation",
			  "type": "address"
			}
		  ],
		  "name": "Upgraded",
		  "type": "event"
		},
		{
		  "inputs": [],
		  "name": "DEFAULT_ADMIN_ROLE",
		  "outputs": [
			{
			  "internalType": "bytes32",
			  "name": "",
			  "type": "bytes32"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "MINTER_ROLE",
		  "outputs": [
			{
			  "internalType": "bytes32",
			  "name": "",
			  "type": "bytes32"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "approve",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "availableToWithdraw",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			}
		  ],
		  "name": "balanceOf",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "offset",
			  "type": "uint256"
			},
			{
			  "internalType": "uint256",
			  "name": "amount",
			  "type": "uint256"
			}
		  ],
		  "name": "batchMintKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "offset",
			  "type": "uint256"
			},
			{
			  "internalType": "uint256",
			  "name": "amount",
			  "type": "uint256"
			}
		  ],
		  "name": "batchResetTokenUri",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "offset",
			  "type": "uint256"
			},
			{
			  "internalType": "uint256",
			  "name": "amount",
			  "type": "uint256"
			}
		  ],
		  "name": "batchTransferKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "burn",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "getApproved",
		  "outputs": [
			{
			  "internalType": "address",
			  "name": "",
			  "type": "address"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "getChainID",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			}
		  ],
		  "name": "getRoleAdmin",
		  "outputs": [
			{
			  "internalType": "bytes32",
			  "name": "",
			  "type": "bytes32"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "uint256",
			  "name": "index",
			  "type": "uint256"
			}
		  ],
		  "name": "getRoleMember",
		  "outputs": [
			{
			  "internalType": "address",
			  "name": "",
			  "type": "address"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			}
		  ],
		  "name": "getRoleMemberCount",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "_owner",
			  "type": "address"
			}
		  ],
		  "name": "getTokenIds",
		  "outputs": [
			{
			  "internalType": "uint256[]",
			  "name": "",
			  "type": "uint256[]"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			}
		  ],
		  "name": "grantRole",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			}
		  ],
		  "name": "hasRole",
		  "outputs": [
			{
			  "internalType": "bool",
			  "name": "",
			  "type": "bool"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "string",
			  "name": "name",
			  "type": "string"
			},
			{
			  "internalType": "string",
			  "name": "symbol",
			  "type": "string"
			},
			{
			  "internalType": "string",
			  "name": "_uri",
			  "type": "string"
			}
		  ],
		  "name": "initialize",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			},
			{
			  "internalType": "address",
			  "name": "operator",
			  "type": "address"
			}
		  ],
		  "name": "isApprovedForAll",
		  "outputs": [
			{
			  "internalType": "bool",
			  "name": "",
			  "type": "bool"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "lockKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			},
			{
			  "internalType": "string",
			  "name": "tokenURI_",
			  "type": "string"
			}
		  ],
		  "name": "mintKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "name",
		  "outputs": [
			{
			  "internalType": "string",
			  "name": "",
			  "type": "string"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "owner",
		  "outputs": [
			{
			  "internalType": "address",
			  "name": "",
			  "type": "address"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "ownerOf",
		  "outputs": [
			{
			  "internalType": "address",
			  "name": "",
			  "type": "address"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "proxiableUUID",
		  "outputs": [
			{
			  "internalType": "bytes32",
			  "name": "",
			  "type": "bytes32"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "redeemer",
			  "type": "address"
			},
			{
			  "components": [
				{
				  "internalType": "uint256",
				  "name": "tokenId",
				  "type": "uint256"
				},
				{
				  "internalType": "uint256",
				  "name": "minPrice",
				  "type": "uint256"
				},
				{
				  "internalType": "string",
				  "name": "uri",
				  "type": "string"
				},
				{
				  "internalType": "bytes",
				  "name": "signature",
				  "type": "bytes"
				}
			  ],
			  "internalType": "struct KCT_721_LazyNFT_V1.NFTVoucher",
			  "name": "voucher",
			  "type": "tuple"
			}
		  ],
		  "name": "redeem",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "payable",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "renounceOwnership",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			}
		  ],
		  "name": "renounceRole",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			},
			{
			  "internalType": "string",
			  "name": "tokenURI_",
			  "type": "string"
			}
		  ],
		  "name": "resetURI",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			}
		  ],
		  "name": "revokeRole",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "from",
			  "type": "address"
			},
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "safeTransferFrom",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "from",
			  "type": "address"
			},
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			},
			{
			  "internalType": "bytes",
			  "name": "_data",
			  "type": "bytes"
			}
		  ],
		  "name": "safeTransferFrom",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "operator",
			  "type": "address"
			},
			{
			  "internalType": "bool",
			  "name": "approved",
			  "type": "bool"
			}
		  ],
		  "name": "setApprovalForAll",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "string",
			  "name": "baseUri_",
			  "type": "string"
			}
		  ],
		  "name": "setBaseUri",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes4",
			  "name": "interfaceId",
			  "type": "bytes4"
			}
		  ],
		  "name": "supportsInterface",
		  "outputs": [
			{
			  "internalType": "bool",
			  "name": "",
			  "type": "bool"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "symbol",
		  "outputs": [
			{
			  "internalType": "string",
			  "name": "",
			  "type": "string"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "index",
			  "type": "uint256"
			}
		  ],
		  "name": "tokenByIndex",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "index",
			  "type": "uint256"
			}
		  ],
		  "name": "tokenOfOwnerByIndex",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "tokenURI",
		  "outputs": [
			{
			  "internalType": "string",
			  "name": "",
			  "type": "string"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "totalSupply",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "from",
			  "type": "address"
			},
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "transferFrom",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "newOwner",
			  "type": "address"
			}
		  ],
		  "name": "transferOwnership",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "unlockKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "newImplementation",
			  "type": "address"
			}
		  ],
		  "name": "upgradeTo",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "newImplementation",
			  "type": "address"
			},
			{
			  "internalType": "bytes",
			  "name": "data",
			  "type": "bytes"
			}
		  ],
		  "name": "upgradeToAndCall",
		  "outputs": [],
		  "stateMutability": "payable",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "version",
		  "outputs": [
			{
			  "internalType": "string",
			  "name": "",
			  "type": "string"
			}
		  ],
		  "stateMutability": "pure",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "withdraw",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		}
	  ]
}

export const pfpContract_live = {
	address: "0x8Db7Af4C6420d6c9ad881D91259970A61143773b",
	abi:  [
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": false,
			  "internalType": "address",
			  "name": "previousAdmin",
			  "type": "address"
			},
			{
			  "indexed": false,
			  "internalType": "address",
			  "name": "newAdmin",
			  "type": "address"
			}
		  ],
		  "name": "AdminChanged",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "approved",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "Approval",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "operator",
			  "type": "address"
			},
			{
			  "indexed": false,
			  "internalType": "bool",
			  "name": "approved",
			  "type": "bool"
			}
		  ],
		  "name": "ApprovalForAll",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "beacon",
			  "type": "address"
			}
		  ],
		  "name": "BeaconUpgraded",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "previousOwner",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "newOwner",
			  "type": "address"
			}
		  ],
		  "name": "OwnershipTransferred",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "previousAdminRole",
			  "type": "bytes32"
			},
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "newAdminRole",
			  "type": "bytes32"
			}
		  ],
		  "name": "RoleAdminChanged",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "sender",
			  "type": "address"
			}
		  ],
		  "name": "RoleGranted",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "sender",
			  "type": "address"
			}
		  ],
		  "name": "RoleRevoked",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "from",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "indexed": true,
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "Transfer",
		  "type": "event"
		},
		{
		  "anonymous": false,
		  "inputs": [
			{
			  "indexed": true,
			  "internalType": "address",
			  "name": "implementation",
			  "type": "address"
			}
		  ],
		  "name": "Upgraded",
		  "type": "event"
		},
		{
		  "inputs": [],
		  "name": "DEFAULT_ADMIN_ROLE",
		  "outputs": [
			{
			  "internalType": "bytes32",
			  "name": "",
			  "type": "bytes32"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "MINTER_ROLE",
		  "outputs": [
			{
			  "internalType": "bytes32",
			  "name": "",
			  "type": "bytes32"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "approve",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "availableToWithdraw",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			}
		  ],
		  "name": "balanceOf",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "offset",
			  "type": "uint256"
			},
			{
			  "internalType": "uint256",
			  "name": "amount",
			  "type": "uint256"
			}
		  ],
		  "name": "batchMintKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "offset",
			  "type": "uint256"
			},
			{
			  "internalType": "uint256",
			  "name": "amount",
			  "type": "uint256"
			}
		  ],
		  "name": "batchResetTokenUri",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "offset",
			  "type": "uint256"
			},
			{
			  "internalType": "uint256",
			  "name": "amount",
			  "type": "uint256"
			}
		  ],
		  "name": "batchTransferKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "burn",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "getApproved",
		  "outputs": [
			{
			  "internalType": "address",
			  "name": "",
			  "type": "address"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "getChainID",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			}
		  ],
		  "name": "getRoleAdmin",
		  "outputs": [
			{
			  "internalType": "bytes32",
			  "name": "",
			  "type": "bytes32"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "uint256",
			  "name": "index",
			  "type": "uint256"
			}
		  ],
		  "name": "getRoleMember",
		  "outputs": [
			{
			  "internalType": "address",
			  "name": "",
			  "type": "address"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			}
		  ],
		  "name": "getRoleMemberCount",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "_owner",
			  "type": "address"
			}
		  ],
		  "name": "getTokenIds",
		  "outputs": [
			{
			  "internalType": "uint256[]",
			  "name": "",
			  "type": "uint256[]"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			}
		  ],
		  "name": "grantRole",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			}
		  ],
		  "name": "hasRole",
		  "outputs": [
			{
			  "internalType": "bool",
			  "name": "",
			  "type": "bool"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "string",
			  "name": "name",
			  "type": "string"
			},
			{
			  "internalType": "string",
			  "name": "symbol",
			  "type": "string"
			},
			{
			  "internalType": "string",
			  "name": "_uri",
			  "type": "string"
			}
		  ],
		  "name": "initialize",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			},
			{
			  "internalType": "address",
			  "name": "operator",
			  "type": "address"
			}
		  ],
		  "name": "isApprovedForAll",
		  "outputs": [
			{
			  "internalType": "bool",
			  "name": "",
			  "type": "bool"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "lockKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			},
			{
			  "internalType": "string",
			  "name": "tokenURI_",
			  "type": "string"
			}
		  ],
		  "name": "mintKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "name",
		  "outputs": [
			{
			  "internalType": "string",
			  "name": "",
			  "type": "string"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "owner",
		  "outputs": [
			{
			  "internalType": "address",
			  "name": "",
			  "type": "address"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "ownerOf",
		  "outputs": [
			{
			  "internalType": "address",
			  "name": "",
			  "type": "address"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "proxiableUUID",
		  "outputs": [
			{
			  "internalType": "bytes32",
			  "name": "",
			  "type": "bytes32"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "redeemer",
			  "type": "address"
			},
			{
			  "components": [
				{
				  "internalType": "uint256",
				  "name": "tokenId",
				  "type": "uint256"
				},
				{
				  "internalType": "uint256",
				  "name": "minPrice",
				  "type": "uint256"
				},
				{
				  "internalType": "string",
				  "name": "uri",
				  "type": "string"
				},
				{
				  "internalType": "bytes",
				  "name": "signature",
				  "type": "bytes"
				}
			  ],
			  "internalType": "struct KCT_721_LazyNFT_V1.NFTVoucher",
			  "name": "voucher",
			  "type": "tuple"
			}
		  ],
		  "name": "redeem",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "payable",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "renounceOwnership",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			}
		  ],
		  "name": "renounceRole",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			},
			{
			  "internalType": "string",
			  "name": "tokenURI_",
			  "type": "string"
			}
		  ],
		  "name": "resetURI",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes32",
			  "name": "role",
			  "type": "bytes32"
			},
			{
			  "internalType": "address",
			  "name": "account",
			  "type": "address"
			}
		  ],
		  "name": "revokeRole",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "from",
			  "type": "address"
			},
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "safeTransferFrom",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "from",
			  "type": "address"
			},
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			},
			{
			  "internalType": "bytes",
			  "name": "_data",
			  "type": "bytes"
			}
		  ],
		  "name": "safeTransferFrom",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "operator",
			  "type": "address"
			},
			{
			  "internalType": "bool",
			  "name": "approved",
			  "type": "bool"
			}
		  ],
		  "name": "setApprovalForAll",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "string",
			  "name": "baseUri_",
			  "type": "string"
			}
		  ],
		  "name": "setBaseUri",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "bytes4",
			  "name": "interfaceId",
			  "type": "bytes4"
			}
		  ],
		  "name": "supportsInterface",
		  "outputs": [
			{
			  "internalType": "bool",
			  "name": "",
			  "type": "bool"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "symbol",
		  "outputs": [
			{
			  "internalType": "string",
			  "name": "",
			  "type": "string"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "index",
			  "type": "uint256"
			}
		  ],
		  "name": "tokenByIndex",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "owner",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "index",
			  "type": "uint256"
			}
		  ],
		  "name": "tokenOfOwnerByIndex",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "tokenURI",
		  "outputs": [
			{
			  "internalType": "string",
			  "name": "",
			  "type": "string"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "totalSupply",
		  "outputs": [
			{
			  "internalType": "uint256",
			  "name": "",
			  "type": "uint256"
			}
		  ],
		  "stateMutability": "view",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "from",
			  "type": "address"
			},
			{
			  "internalType": "address",
			  "name": "to",
			  "type": "address"
			},
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "transferFrom",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "newOwner",
			  "type": "address"
			}
		  ],
		  "name": "transferOwnership",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "uint256",
			  "name": "tokenId",
			  "type": "uint256"
			}
		  ],
		  "name": "unlockKCT",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "newImplementation",
			  "type": "address"
			}
		  ],
		  "name": "upgradeTo",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		},
		{
		  "inputs": [
			{
			  "internalType": "address",
			  "name": "newImplementation",
			  "type": "address"
			},
			{
			  "internalType": "bytes",
			  "name": "data",
			  "type": "bytes"
			}
		  ],
		  "name": "upgradeToAndCall",
		  "outputs": [],
		  "stateMutability": "payable",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "version",
		  "outputs": [
			{
			  "internalType": "string",
			  "name": "",
			  "type": "string"
			}
		  ],
		  "stateMutability": "pure",
		  "type": "function"
		},
		{
		  "inputs": [],
		  "name": "withdraw",
		  "outputs": [],
		  "stateMutability": "nonpayable",
		  "type": "function"
		}
	  ]
}

export const SEND_ADDRESS_TO_MINTING =
	process.env.REACT_APP_SEND_ADDRESS_TO_MINTING;
export const SPEEDY_NODEAPI_KEY = process.env.REACT_APP_SPEEDY_NODEAPI_KEY;

export const CONTRACT_INFO =
	process.env.REACT_APP_CHAIN_TARGET == 'goerli'
		? staking_testnet
		: staking_live;
export const TOKEN_INFO =
	process.env.REACT_APP_CHAIN_TARGET == 'goerli' ? token_testnet : token_live;
export const SHILLA_CONTRACT =
	process.env.REACT_APP_CHAIN_TARGET == 'goerli'
		? LockupShillaContract_testnet
		: LockupShillaContract_live;
export const PFP_CONTRACT =
	process.env.REACT_APP_CHAIN_TARGET == 'goerli'
		? pfpContract_testnet
		: pfpContract_live;
